"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.styledBox = styledBox;
exports["default"] = exports.styledProvider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _Theme = require("../Theme");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var __jsx = _react["default"].createElement;
var boxStyles = {
  boxSizing: "border-box",
  minWidth: "0px",
  margin: 0,
  padding: 0,
  border: 0,
  listStyle: "none"
};
var focusReset = {
  ":focus": {
    outline: "none"
  }
};
var fitChildStyles = {
  position: "relative",
  "> *": {
    minWidth: "inherit !important",
    maxWidth: "inherit !important",
    width: "100% !important"
  }
};
var fitChildHeightStyles = {
  position: "relative",
  "> *": {
    minHeight: "inherit !important",
    maxHeight: "inherit !important",
    height: "100% !important"
  }
};

var styledProvider = function styledProvider(theme) {
  return function () {
    var as = "div";
    var obj = arguments.length <= 0 ? undefined : arguments[0];
    var extraProps = arguments.length <= 1 ? undefined : arguments[1];

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
      as = arguments.length <= 0 ? undefined : arguments[0];
      obj = arguments.length <= 1 ? undefined : arguments[1];
      extraProps = arguments.length <= 2 ? undefined : arguments[2];
    }

    return styledBox(as, obj, extraProps, theme);
  };
};

exports.styledProvider = styledProvider;

function styledBox(as, obj) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var theme = arguments.length > 3 ? arguments[3] : undefined;

  if (typeof obj !== "object") {
    throw new Error("Dupa, can't use function");
  }

  var fitW = extraProps.fitW,
      fitH = extraProps.fitH,
      noFocus = extraProps.noFocus,
      restProps = (0, _objectWithoutProperties2["default"])(extraProps, ["fitW", "fitH", "noFocus"]);
  var rootStyles = (0, _objectSpread2["default"])({}, boxStyles, fitW && fitChildStyles, fitH && fitChildHeightStyles, (theme.hideFocus || noFocus) && focusReset);
  var hasFunctions = false; // static styles calculated only once in styledBox function. dynamicStyles must be recalculated at runtime

  var staticStyles = {};

  for (var key in obj) {
    if (typeof obj[key] === "function") {
      hasFunctions = true;
    } else {
      staticStyles[key] = obj[key];
    }
  }

  staticStyles = (0, _.css)(staticStyles)(theme); // compile static styles

  var dynamicStyles;

  if (hasFunctions) {
    dynamicStyles = function dynamicStyles(props) {
      var dynamicStyles = {};

      for (var _key in obj) {
        if (typeof obj[_key] === "function") {
          dynamicStyles[_key] = obj[_key](props);
        } else {// newObj[key] = obj[key];
        }
      }

      dynamicStyles = (0, _.css)(dynamicStyles)(theme); // compile static styles

      return dynamicStyles;
    };
  }

  var result = [rootStyles, staticStyles];

  if (dynamicStyles) {
    result.push(dynamicStyles);
  }

  var RawDiv = (0, _styled["default"])(as).apply(void 0, result); // This below takes some performance hit, don't know why. Maybe it's just the issue of number of components and dev mode.

  var Component = _react["default"].forwardRef(function (props, ref) {
    if (props.__portals__) {
      return __jsx(_react["default"].Fragment, null, props.__portals__, __jsx(RawDiv, (0, _extends2["default"])({}, restProps, props, {
        ref: ref
      })));
    }

    return _react["default"].createElement(RawDiv, (0, _objectSpread2["default"])({}, props, {
      ref: ref
    }));
  });

  return Component;
}

function Box_(props) {
  var sx = props.sx,
      as = props.as,
      _ref = props._ref,
      _props$noFocus = props.noFocus,
      noFocus = _props$noFocus === void 0 ? false : _props$noFocus,
      _props$fitChild = props.fitChild,
      fitChild = _props$fitChild === void 0 ? false : _props$fitChild,
      _props$fitChildHeight = props.fitChildHeight,
      fitChildHeight = _props$fitChildHeight === void 0 ? false : _props$fitChildHeight,
      fitW = props.fitW,
      fitH = props.fitH,
      __portals__ = props.__portals__,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "as", "_ref", "noFocus", "fitChild", "fitChildHeight", "fitW", "fitH", "__portals__"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var t = (0, _Theme.useTheme)();

  if (fitW === true) {
    fitChild = true;
  }

  if (fitH === true) {
    fitChildHeight = true;
  }

  var ret = (0, _.jsx)(as, (0, _objectSpread2["default"])({
    sx: [boxStyles, (t.hideFocus || noFocus) && focusReset, fitChild && fitChildStyles, fitChildHeight && fitChildHeightStyles, css],
    ref: _ref
  }, restProps));

  if (__portals__) {
    return __jsx(_react["default"].Fragment, null, __portals__, ret);
  }

  return ret;
}

var Box = _react["default"].forwardRef(function (props, ref) {
  return __jsx(Box_, (0, _extends2["default"])({
    _ref: ref
  }, props));
});

Box.defaultProps = {
  as: "div"
};
var _default = Box;
/**
 What do we want?

 css={{
    color: "primary", // colors by simple string from theme,
    font: "heading1", // fonts that compile to a group of properties
    padding: rslin(10, 20), // linear spacings, responsive sizes,
    "media-query": {
        color: "blue" // media queries available directly
    }
 }}

 rslin(10, 20)
 {
    _: 0,
    md: rslin(10, 20)
 }

 We want easy access to:
 - h1, h2, h3, h4, etc.
 - p
 - ul, li, ol
 - section etc.
 - A
 - <Ul>
 - <Li>

 sx!!!

 <ul sx={} />

 <li sx={{}}

 They should have some nice default styles, but easily overrideable.

 If we want to use native HTML elements, we must remember that then can't have default styles defined in any other way than global styles.


 NATYWNE KOMPONENTY CZY NIE?
 - na razie natywne!!! z sx. Potem możemy rozszerzać. Możemy zostawić Box i Text na razie (w sumie to samo tylko inny default "as" na "p", lol)
 - czyli co, wgrywamy theme-ui?

 ZALETY NIENATYWNYCH
 - możemy mieć kontrolę nad propsami i wtedy np. wiedzieć, że żaden komponent w środku jakiegoś komponentu nie zrobi position: fixed czy coś. Można to realnie zablokować :O ZAJEBIŚCIE.
 - zacznijmy od Box i Text.


 THINGS TO DO:
 - One big css() function that takes "our form of css" (with theme styles, fonts, responsive sizes) and compiles to emotion form. It should be wrapper around css from styled-system.
 - W całej appce posługujemy sie naszymi obiektami, dopiero na SAM KONIEC kompilujemy style do styli emotion.
 - Rozkmiń kolejnośc media query etc.

 **/

exports["default"] = _default;